module.exports = __webpack_public_path__ + "10_mole.da621d89.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer2/10_mole.png
// module id = HsEm
// module chunks = 0